module.exports = __webpack_public_path__ + "img/parpar.e4bda363.svg";